import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Uvod ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("S")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": "0",
    "background-color": "#545c64",
    "text-color": "#fff",
    "active-text-color": "#ffd04b"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu_item, {
        index: "0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleOpen(0)))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Games, (game, i) => {
        return (_openBlock(), _createBlock(_component_el_menu_item, {
          key: game.id,
          index: i+1,
          onClick: ($event: any) => (_ctx.handleOpen(i+1))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { align: "middle" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_avatar, {
                      size: 50,
                      src: game.icon,
                      class: "game-icon"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 2
                    }, 1032, ["src"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_col, {
                  span: 20,
                  class: "name-text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(game.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["index", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}